import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  AreaChart,
  Area,
} from "recharts";
import { useTheme } from "@mui/material";
import pl from "date-fns/locale/pl";
import format from "date-fns/format";
import { Typography, Box } from "@mui/material";

const CustomTooltip = ({ active, payload, label, theme }) => {
  if (active && payload && payload.length) {
    //
    //

    return (
      <Box
        sx={{
          backgroundColor: theme.palette.primary.dark,
          borderRadius: "15px",
          padding: "2rem",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "flex-start",
        }}
      >
        <Typography variant="h3">
          Godzina:{" "}
          <span style={{ fontWeight: "bold" }}>
            {format(new Date(label), "HH:mm")}
          </span>
        </Typography>
        <Typography variant="h3">
          Moc:{" "}
          <span style={{ fontWeight: "bold" }}>
            {payload[0].value / 1000} kW
          </span>
        </Typography>
      </Box>
    );
  }

  return null;
};

const PowerChart = ({ powerData }) => {
  const theme = useTheme();
  return (
    <ResponsiveContainer width="100%" height="100%">
      <LineChart
        data={powerData}
        margin={{
          top: 50,
          right: 30,
          left: 30,
          bottom: 20,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          tick={{ fill: theme.palette.text.secondary }}
          minTickGap={50}
          dataKey="x"
          label={{
            fill: theme.palette.text.secondary,
            value: "Godzina",
            angle: 0,
            fontSize: "15",
            offset: "-5",
            fontWeight: "300",
            position: "insideBottomLeft",
          }}
          tickFormatter={(value) => {
            //
            //
            if (value) {
              return format(new Date(value), "HH:mm", { locale: pl });
            }
          }}
        />
        <YAxis
          tick={{ fill: theme.palette.text.secondary }}
          tickFormatter={(value) => {
            return value / 1000;
          }}
          label={{
            fill: theme.palette.text.secondary,
            value: "kW",
            angle: 0,
            fontSize: "15",
            offset: "15",
            fontWeight: "300",
            position: "top",
          }}
        />

        {/* <Legend /> */}
        <Line
          dot={false}
          type="monotone"
          dataKey="y"
          // data={parseReactivePowers(powerData)[0]}
          strokeWidth={3}
          stroke={theme.palette.primary.success}
          name="Moc"
          activeDot={{ r: 8 }}
        />
        <Tooltip content={<CustomTooltip theme={theme} />} />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default PowerChart;
